import type { User } from '../../auth/types/auth.types'
import { api } from '../../../shared/services/api'

import type {
  Article,
  ArticleAttachment,
  ArticleFormPayload,
  ArticleMarkdownPreview,
  AttachmentUploadUrlRequest,
  AttachmentUploadUrlResponse,
  CompleteAttachmentUploadRequest,
} from '../types/article.types'

export const articleApi = {
  list: (params?: { state?: string; mine?: boolean }) => api.get<Article[]>('/articles', { params }),
  get: (id: string | number) => api.get<Article>(`/articles/${id}`),
  getMarkdownPreview: (id: string | number) => api.get<ArticleMarkdownPreview>(`/articles/${id}/markdown-preview`),
  create: (data: ArticleFormPayload) => api.post<Article>('/articles', data),
  update: (id: string | number, data: ArticleFormPayload) => api.put<Article>(`/articles/${id}`, data),
  submit: (id: string | number) => api.post(`/articles/${id}/submit`),
  assignReviewer: (id: string | number, reviewerId: string | number) => api.post(`/articles/${id}/assign-reviewer`, { reviewer_id: reviewerId }),
  approve: (id: string | number) => api.post(`/articles/${id}/approve`),
  reject: (id: string | number, comment: string) => api.post(`/articles/${id}/reject`, { comment }),
  requestChanges: (id: string | number, data: { request_type: string; comment: string; deadline: string }) =>
    api.post(`/articles/${id}/request-changes`, data),
  publish: (id: string | number) => api.post(`/articles/${id}/publish`),
  archive: (id: string | number) => api.post<Article>(`/articles/${id}/archive`),
  rollbackToDraft: (id: string | number) => api.post<Article>(`/articles/${id}/rollback-to-draft`),
  remove: (id: string | number) => api.delete<{ success: boolean }>(`/articles/${id}`),
  listUsers: () => api.get<User[]>('/articles/users'),
  createAttachmentUploadUrl: (id: string | number, data: AttachmentUploadUrlRequest) =>
    api.post<AttachmentUploadUrlResponse>(`/articles/${id}/attachments/upload-url`, data),
  completeAttachmentUpload: (id: string | number, data: CompleteAttachmentUploadRequest) =>
    api.post<ArticleAttachment>(`/articles/${id}/attachments/complete`, data),
  uploadAttachment: (id: string | number, file: File, attachmentType = 'file') => {
    const form = new FormData()
    form.append('file', file)
    form.append('attachment_type', attachmentType)
    return api.post(`/articles/${id}/attachments`, form)
  },
  downloadAttachment: (articleId: string | number, attachmentId: string | number) => {
    const base = process.env.REACT_APP_API_URL || 'http://localhost:4000/api'
    return `${base}/articles/${articleId}/attachments/${attachmentId}`
  },
  publicImageUrl: (articleId: string | number, attachmentId: string | number) => {
    const base = process.env.REACT_APP_API_URL || 'http://localhost:4000/api'
    return `${base}/articles/public/${articleId}/attachments/${attachmentId}`
  },
}
